import React from 'react'

import useTranslation from '../../../context/hooks/useTranslation'
import ErrorIcon from '../../../vectors/ErrorIcon'

export const ScanResultError: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="shadow-elevation-2 flex h-[537px] w-[840px] flex-row overflow-hidden rounded-lg bg-white">
      <div className="bg-gray-90 flex w-1/2 flex-col items-center justify-center gap-4">
        <ErrorIcon />
        <span className="font-heading text-center text-[40px] text-white">
          {t('RETURNS_SCAN.ERROR')}
        </span>
      </div>

      <div className="flex w-1/2 flex-col items-start px-6 pt-32 text-indigo-50">
        <div className="flex flex-col">
          <span className="font-heading text-h3 text-center">
            {t('RETURNS_SCAN.SCAN_ERROR_TITLE')}
          </span>
          <span className="font-body text-md text-center">
            {t('RETURNS_SCAN.SCAN_ERROR_DETAILS')}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ScanResultError
